eval("define(\'orosync/js/extend/when\',[\'when\'], function(when) {\n    \'use strict\';\n\n    window.when = when;\n\n    return when;\n});\n\n//# sourceURL=/orosync/js/extend/when.js");

